var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketingStatusFollowingIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Following",
    transform: "translate(-452 -194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161132",
    "data-name": "Group 161132",
    transform: "translate(452 194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161125",
    "data-name": "Group 161125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2354",
    "data-name": "Path 2354",
    d: "M7,0A7,7,0,1,1,0,7,7,7,0,0,1,7,0Z",
    transform: "translate(0)",
    fill: "#fef1cf"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "star-svgrepo-com",
    d: "M10.253,6.888,9.26,5,8.267,6.888a.989.989,0,0,1-.3.349,1,1,0,0,1-.424.18l-2.046.4L6.929,9.527a.994.994,0,0,1,.252.791l-.272,2.2,1.884-.913A1.074,1.074,0,0,1,9.26,11.5a.946.946,0,0,1,.435.107l1.928.857-.272-2.176A.994.994,0,0,1,11.6,9.5L13.02,7.818l-2.046-.4a1,1,0,0,1-.424-.18A.989.989,0,0,1,10.253,6.888Z",
    transform: "translate(449.74 192.076)",
    fill: "none",
    stroke: "#e1a405",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketingStatusFollowingIcon);
export default __webpack_public_path__ + "static/media/ticketing-status-following-icon.36322aa4c7fad11807e777b5b7cc36b2.svg";
export { ForwardRef as ReactComponent };